import { useState } from "react";
import { UserPlus } from "lucide-react";
import { ManualLeadDialog } from "./ManualLeadDialog";

/**
 * Button that opens the ManualLeadDialog.
 * Placed on the BldrOS dashboard for quick access.
 */
export function QuickAddLeadButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors cursor-pointer"
      >
        <UserPlus className="w-4 h-4" />
        New Lead
      </button>
      <ManualLeadDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
